<template>
  <!------------------------------------------>
  <!-- EXECUTE TRANSFORMATIONS ---------------->
  <!------------------------------------------>
  <v-card class="custom_card" elevation="0">
    <v-card-title>
      <v-row no-gutters class="my-4">
        <v-col cols="12" class="text_color d-flex justify-center mt-2 mb-4">
          Ejecutar transformaciones
        </v-col>
        <v-col cols="12" class="d-flex justify-center mb-2">
          <span class="body-2 text_color">
            En esta sección podrás reiniciar las tablas que se encuentran dentro
            de la base de datos seleccionada basado en las transformaciones que
            elijas.
          </span>
        </v-col>
        <v-col cols="12" class="d-flex justify-center mt-2">
          <p class="caption blue--text text--accent-4">
            El procesamiento de las transformaciones se realizará en segundo
            plano, por lo que podrás seguir utilizando la plataforma mientras se
            ejecutan
          </p>
        </v-col>
      </v-row>
    </v-card-title>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card-text class="mt-4">
        <v-row
          no-gutters
          class="d-flex justify-center align-center"
          style="gap: 48px"
        >
          <v-col cols="12" md="5">
            <v-autocomplete
              v-model="database"
              :items="databases"
              :rules="rules.database"
              class="rounded-lg"
              label="Base de datos"
              outlined
              dense
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="5">
            <v-autocomplete
              v-if="database"
              v-model="files"
              :items="filePathsOptions"
              :rules="rules.files"
              class="rounded-lg"
              label="Transformaciones"
              outlined
              multiple
              chips
              dense
            >
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="d-flex justify-end align-end px-6 mb-2">
        <v-btn
          :disabled="!valid"
          :loading="loading"
          color="#2661FF"
          class="rounded-lg"
          @click="executeETL"
        >
          <span class="white--text">
            Ejecutar
          </span>
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Vue from 'vue'
import { etlsService } from '../../services/etls.service'

export default {
  name: 'ExecuteTransformations',
  data () {
    return {
      valid: false,
      loading: false,
      database: null,
      databases: ['analytics', 'staging'],
      files: [],
      filesPaths: {
        analytics: [
          'SESDatamartAnalyticsBulk.ktr',
          'SMSDatamartAnalyticsBulk.ktr',
          'consoleDatamartAnalyticsBulk.ktr',
          'whatsappDatamartAnalyticsBulk.ktr',
          'campaignDatamartAnalyticsBulk.ktr',
          'SESComIdDatamartAnalyticsBulk.ktr',
          'SubscriptionDatamartAnalyticsBulk.ktr',
          'campaignFormsDatamartAnalyticsBulk.ktr',
          'campaignLeadsDatamartAnalyticsBulk.ktr',
          'organizationCountriesAnalyticsBulk.ktr',
          'segmentsLeadsDatamartAnalyticsBulk.ktr',
          'whatsappMsgIdDatamartAnalyticsBulk.ktr',
          'widgetsDashboardDatamartAnalyticsBulk.ktr',
          'organizationCountryStatesAnalyticsBulk.ktr',
          'SubscriptionByMonthDatamartAnalyticsBulk.ktr',
          'ChargesTransactionsDatamartAnalyticsBulk.ktr',
          'organizationCountryStateCitiesAnalyticsBulk.ktr'
        ],
        staging: [
          'ETL_email/Em_open_bulk.ktr',
          'ETL_email/Em_sent_bulk.ktr',
          'ETL_email/Em_click_bulk.ktr',
          'ETL_email/Em_error_bulk.ktr',
          'ETL_email/Em_opt_out_bulk.ktr',
          'ETL_email/Em_complain_bulk.ktr',
          'ETL_email/Em_scheduled_bulk.ktr',
          'ETL_email/Em_soft_bounce_bulk.ktr',
          'ETL_email/Em_hard_bounce_bulk.ktr',
          'ETL_staging_main/lnz_tags_bulk.ktr',
          'ETL_email/Em_notification_bulk.ktr',
          'ETL_staging_main/lnz_leads_bulk.ktr',
          'ETL_staging_main/lnz_score_bulk.ktr',
          'ETL_staging_main/lnz_forms_bulk.ktr',
          'ETL_staging_main/lnz_cities_bulk.ktr',
          'ETL_staging_main/lnz_states_bulk.ktr',
          'ETL_staging_main/lnz_gateways_bulk.ktr',
          'ETL_staging_main/lnz_campaings_bulk.ktr',
          'ETL_staging_main/lnz_donations_bulk.ktr',
          'ETL_staging_main/lnz_countries_bulk.ktr',
          'ETL_staging_main/lnz_tag_leads_bulk.ktr',
          'ETL_email/Em_rendering_failure_bulk.ktr',
          'ETL_staging_main/lnz_currencies_bulk.ktr',
          'ETL_email/Em_comunication_monitor_bulk.ktr',
          'ETL_email/Em_receipt_notification_bulk.ktr',
          'ETL_email/Em_organization_monitor_bulk.ktr',
          'ETL_staging_main/lnz_organizations_bulk.ktr',
          'ETL_staging_main/lnz_document_types_bulk.ktr',
          'ETL_staging_main/lnz_abandoned_events_bulk.ktr',
          'ETL_staging_main/lnz_account_activities_bulk.ktr',
          'ETL_staging_main/lnz_gateway_currencies_bulk.ktr',
          'ETL_staging_main/lnz_lead_communication_channels_bulk.ktr'
        ]
      },
      rules: {
        database: [v => !!v || 'El campo base de dato es requerido'],
        files: [v => !!v.length || 'El campo transformaciones es requerido']
      }
    }
  },
  computed: {
    filePathsOptions () {
      return this.filesPaths[this.database]
    }
  },
  watch: {
    database () {
      this.files = []
    }
  },
  methods: {
    async executeETL () {
      const { database, files } = this

      this.loading = true

      try {
        const validation = this.$refs.form.validate()

        if (!validation) return

        await etlsService.executeTransformation(database, files)

        Vue.noty.success('Transformaciones ejecutadas correctamente')
      } catch (error) {
        Vue.noty.error('Ocurrió un error al ejecutar las transformaciones')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom_card {
  border-radius: 12px !important;
  border: 1px solid #d0d3db !important;
}
.text_color {
  color: #344054 !important;
}
</style>
